export enum Routes {
	LOGIN = "login",
	SIGNUP = "signup",
	DEMO = "demo",
	DASHBOARD = "dashboard",
	TAX_FREE = "tax-free-retirement",
	VAR_APPLICATION = "value-at-risk",
	BROWN_HAM = "brown-and-ham",
	BME680 = "bme680",
	BATTERY_STATE = "battery-state",
	MLX = "mlx90640",
	MOONFIRE = "moonfire",
}

export const RouteToTooltipMap: { [key in string]: { title: string; body: string } } = {
	[Routes.TAX_FREE]: {
		title: "Retirement Savings Modeler with Signaloid's Infrastructure",
		body: "This example estimates the final balance of a retirement savings account by modeling tax rates, interest rates, and other financial uncertainties as probability distributions.",
	},
	[Routes.VAR_APPLICATION]: {
		title: "Value at Risk",
		body: "Value at Risk (VaR) is a widely-used investment risk analysis tool for estimating potential financial losses over a specific time period. This application computes VaR deterministically in one calculation, and uses geometric Brownian motion to model the asset price over time, based on the implementation in “Mathematical Modeling And Computation In Finance” by Oosterlee and Grzelak.",
	},
	[Routes.BROWN_HAM]: {
		title: "Precipitate Dislocation Model from Brown and Ham",
		body:
			"The precipitate dislocation model from Brown and Ham [1] provides metallurgists with insight into a metal alloy’s strength. This application implements the model but treats the inputs as probability distributions, and calculates the output cutting stress distribution using Signaloid’s uncertainty quantification technology. \n \n" +
			'[1] Brown, L. M., and R. K. Ham. "Dislocation-particle interactions." Strengthening methods in crystals (1971): 9–135.',
	},
	[Routes.BME680]: {
		title: "BME680 Calibration Routines",
		body: "Sensors use calibration algorithms to convert transducer readings into physical parameters. Signaloid’s technology lets you quantify how sensor noise and transducer measurement uncertainty can impact your system’s calibrated outputs.",
	},
	[Routes.BATTERY_STATE]: {
		title: "Battery State of Charge Estimation",
		body: "The state of charge of a battery expresses its remaining capacity as a percentage of its total capacity. Accurately estimating the state of charge is crucial in battery-powered systems. This example models the state of charge of a Panasonic CGR-17500 cell from a noisy voltage measurement.",
	},
	[Routes.MLX]: {
		title: "MLX90640 Temperature Sensor",
		body: "The MLX90640 is a high-accuracy, low-power, and low-cost temperature sensor. This example shows how to use the MLX90640 sensor to measure temperature in a smart home environment.",
	},
	[Routes.MOONFIRE]: {
		title: "Moonfire Portfolio Modelling",
		body: "In the ArXiv paper “Venture Capital Portfolio Construction” by Farina et al., they propose a model for the optimal size for a venture capital investment portfolio. This application implements this model, but replaces the Monte Carlo methods proposed in the original with Signaloid’s uncertainty-tracking technology.",
	},
};
